import React, { useEffect, useState } from 'react'
import './bill-view.scss'
import { useNavigate, useParams } from 'react-router-dom'
import SinglePage from '../../components/common/page/SinglePage'
import SpinWithMessage from '../../components/common/spinners/SpinWithMessage'
import { accountingAxios } from '../../config/axios'
import { FaDotCircle } from 'react-icons/fa'
import { formatStringDate, formatAmount } from '../../assets/javascript/formate-functions'
import toast from 'react-hot-toast'



function TransactionView() {
    const { transaction_uuid } = useParams()
    const [data, setData] = useState({})
    const navigate = useNavigate()
    const [loading, setLoading] = useState('fetch')

    const handleAccept = () => {

        const ask = window.confirm('Are you ready to Accept the transaction ?')

        if (ask) {
            setLoading('approve')
            accountingAxios.patch(`/v2/transaction/${transaction_uuid}/approve`).then((response) => {

                setData({
                    ...data,
                    transaction_status: 'SUCCESS'
                })
                setLoading('')
                toast.success('Transaction accepted')

            }).catch((error) => {
                toast.error(error?.message)
                setLoading('')
            })
        }

    }

    const handleReject = () => {

        const ask = window.confirm('Are you ready to Reject the transaction ?')

        if (ask) {
            setLoading('reject')
            accountingAxios.patch(`/v2/transaction/${transaction_uuid}/reject`).then((response) => {

                setData({
                    ...data,
                    transaction_status: 'REJECTED'
                })
                setLoading('')
                toast.success('Transaction rejected')

            }).catch((error) => {
                toast.error(error?.message)
                setLoading('')
            })
        }
    }


    useEffect(() => {
        accountingAxios.get(`/v2/transaction/${transaction_uuid}`).then((response) => {
            if (response.data) {
                setData(response.data)
                setLoading('')
            } else {
                navigate('/')
                setLoading('')
            }
        })

        // eslint-disable-next-line
    }, [])

    return (
        <div className='single-bill-view'>
            <SinglePage titleArray={[`Transaction View / ${data?.transaction_id ?? 'Loading...'}`]}>
                {loading === 'fetch'
                    ? <SpinWithMessage message={'Fetch data...'} />
                    :
                    <>
                        <div className="top-div" style={{ justifyContent: 'flex-end' }}>
                            <div className="buttons-div">
                                <button onClick={() => navigate(`/receipts?receipt_no=${data?.receipt_no}`)}>Receipt</button>
                                <button onClick={() => navigate(`/allocations?transaction_id=${data?.transaction_id}`)}>Allocations</button>
                            </div>
                        </div>
                        <div className="single-border">
                            <div className="section-one">
                                {/* Service Details */}
                                <div className="card-div">
                                    <div className="head-div">
                                        <FaDotCircle />
                                        <h4>About Transaction</h4>
                                    </div>
                                    <div className="content-div">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td>Transaction Id</td>
                                                    <td>: {data?.transaction_id}</td>
                                                </tr>
                                                <tr>
                                                    <td>Payment Date</td>
                                                    <td>: {data?.payment_date ? formatStringDate(data?.payment_date) : 'Nil'}</td>
                                                </tr>
                                                <tr>
                                                    <td>Receipt No</td>
                                                    <td>: {data?.receipt_no || 'Nil'}</td>
                                                </tr>
                                                <tr>
                                                    <td>Method</td>
                                                    <td>: {data?.payment_mode} </td>
                                                </tr>
                                                <tr style={{ fontWeight: "700" }}>
                                                    <td>Amount</td>
                                                    <td>: ₹{formatAmount(data?.amount)}</td>
                                                </tr>
                                                <tr>
                                                    <td>Status</td>
                                                    <td>: {data?.transaction_status ?? ''}</td>
                                                </tr>
                                                {data?.failure_reason && <tr>
                                                    <td>Failure Reason</td>
                                                    <td>: {data?.failure_reason} </td>
                                                </tr>}
                                                <tr>
                                                    <td>Status Update By</td>
                                                    <td>: {data?.status_updated_by ? data?.status_updated_by : 'SYSTEM'}</td>
                                                </tr>
                                                <tr>
                                                    <td>Status Update Time</td>
                                                    <td>: {data?.status_updated_at ? formatStringDate(data?.status_updated_at) : 'Nil'}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="card-div">
                                    <div className="head-div">
                                        <FaDotCircle />
                                        <h4>About {data?.payment_mode}</h4>
                                    </div>
                                    <div className="content-div">
                                        <table>
                                            <tbody>
                                                {data?.payment_mode === 'BANK' && <>
                                                    <tr>
                                                        <td>Transaction Id</td>
                                                        <td>: {data?.bank?.txn_id ?? 'Nil'} </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Bank Name</td>
                                                        <td>: {data?.bank?.bank_name ?? 'Nil'} </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Account No</td>
                                                        <td>: {data?.bank?.account_last4 ? `******${data?.bank?.account_last4}` : "Nill"} </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Ifsc Code</td>
                                                        <td>: {data?.bank?.ifsc ?? 'Nil'} </td>
                                                    </tr>
                                                </>}
                                                {data?.payment_mode === 'CHEQUE' && <>
                                                    <tr>
                                                        <td>Cheque No</td>
                                                        <td>: {data?.cheque?.cheque_no ?? 'Nil'} </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Bank Name</td>
                                                        <td>: {data?.cheque?.bank_name ?? 'Nil'} </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Check Date</td>
                                                        <td>: {data?.cheque?.cheque_date ? formatStringDate(data?.cheque?.cheque_date) : "Nill"} </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Clearance Date</td>
                                                        <td>: {data?.cheque?.clearance_date ?? 'Nil'} </td>
                                                    </tr>
                                                </>}
                                                {data?.payment_mode === 'WALLET' && <>
                                                    <tr>
                                                        <td>Wallet Id</td>
                                                        <td>: {data?.wallet?.wallet_id ?? 'Nil'} </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Reference</td>
                                                        <td>: {data?.wallet?.reference ?? 'Nil'} </td>
                                                    </tr>
                                                </>}
                                                {data?.payment_mode === 'CASH' && <>
                                                    <tr>
                                                        <td>Collected Amount</td>
                                                        <td>: ₹{formatAmount(data?.amount)}</td>
                                                    </tr>
                                                </>}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {data?.transaction_status === 'PENDING_CLEARANCE' && <>
                            <div className="bottom-div">
                                <p>The transaction is pending, Take a action below:</p>
                                <div className="buttons-div">
                                    <button style={{ backgroundColor: 'green' }} onClick={handleAccept}>{loading ? "Wait..." : "Approve"}</button>
                                    <button style={{ backgroundColor: 'red' }} onClick={handleReject}>{loading ? "Wait..." : "Reject"}</button>
                                </div>
                            </div>
                        </>}
                    </>}
            </SinglePage>
        </div >
    )
}

export default TransactionView